import React from 'react';
import HomeFloorBox from './home-floor-box';
import Pick11Card from './pick11-card';
import {P11MatchItem} from '@/pages/home/home.type';
import {getPick11GameUrl} from '@/pages/home/home.service';
import globalStore from '@/services/global.state';
import {goTo} from '@/utils';

interface HomeFloorPick11Props {
  name: string;
  id: string;
  shown?: boolean;
  categoryPic?: string;
  icon?: string;
  pick11List: P11MatchItem[];
}

const HomeFloorPick11 = ({
  name,
  id,
  shown = true,
  categoryPic,
  icon,
  pick11List,
}: HomeFloorPick11Props) => {
  const handleNavigate = async (matchId?: number) => {
    if (!globalStore.token) {
      goTo('Login', {backPage: 'Home'});
      return;
    }

    globalStore.globalLoading.next(true);
    try {
      const res = await getPick11GameUrl();
      const baseUrl =
        typeof res === 'string' ? res : (res as {token?: string})?.token || '';

      if (!baseUrl) {
        return;
      }

      const originUrl =
        matchId != null
          ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}matchId=${matchId}`
          : baseUrl;

      goTo('WebView', {
        header: true,
        hideAmount: true,
        headerTitle: 'Pick11',
        originUrl,
      });
    } finally {
      globalStore.globalLoading.next(false);
    }
  };

  if (!shown || pick11List.length === 0) {
    return null;
  }

  return (
    <HomeFloorBox
      gameType="pick11"
      id={id}
      name={name}
      className="anna-pick11-floor"
      headerClassName="anna-pick11-floor__header"
      bodyClassName="anna-pick11-floor__body"
      iconClassName="anna-pick11-floor__icon"
      titleClassName="anna-pick11-floor__title"
      rightNodeWrapClassName="anna-pick11-floor__right"
      bg={categoryPic}
      categoryPic={categoryPic}
      icon={icon}
      rightNode={
        <div
          onClick={() => handleNavigate()}
          className="text-c1 text-xs font-bold px-2 py-1 rounded-lg bg-white border border-[#9FA6AC]">
          All
        </div>
      }
      childrenWrapClassName="w-full flex-col gap-2">
      {pick11List.map((match, index) => (
        <Pick11Card
          key={match.id ?? match.fantasyMatchId ?? index}
          match={match}
          className="anna-pick11-card"
          onClick={() => handleNavigate(match.fantasyMatchId ?? match.id)}
        />
      ))}
    </HomeFloorBox>
  );
};

export default HomeFloorPick11;
